<template>
  <a-drawer width="70%" :label-col="4" :wrapper-col="14" :visible="open"  @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>Order Details</b>
    </a-divider>
    <!--订单状态步骤条-->
    <a-steps v-if="this.record.id" :current="this.record.orderStatus" size="small">
      <a-step v-for="(item, index) in this.record.operateLogList" :key="index" >
        <template slot="title">
          <div class="step-event">{{ translateStatus(item.statusEvent) }}</div>
          <div class="step-status">{{ translateStatus(item.orderStatusName) }}</div>
          <div v-if="item.remark" class="step-remark">{{ translateStatus(item.remark) }}</div>
          <div class="step-time">{{ item.createTime }}</div>
        </template>
      </a-step>
    </a-steps>

    <div class="order-info">
      <table>
        <tr>
          <td style="vertical-align: top;background-color:#fbfbfb;">
            <a-card  :bordered="false" title="Order Info"
                    :headStyle="{'background-color':'#f3f3f3','height': '29px','border-bottom': '1px solid #DDD','margin-bottom':'0'}"
                    :bodyStyle="{'background-color':'#fbfbfb'}">
              <table class="info-table">
                <tr>
                  <td class="first">Order No:</td>
                  <td class="data">
                    {{ this.record.id}}
                  </td>
                  <td class="first">Order Status:</td>
                  <td class="data">
                    {{translateStatus(this.record.orderStatusName)}}
                  </td>
                  <td class="first">Order Time:</td>
                  <td class="data">
                    {{ this.record.createTime}}
                  </td>
                </tr>
<!--                <tr>
                  <td class="first">Parent Order No:</td>
                  <td class="data">
                    {{ this.record.parentId}}
                  </td>
                </tr>-->
                <tr>
                  <td class="first">Order Source:</td>
                  <td class="data">
                    {{ this.record.sourceName}}
                  </td>
                  <td class="first">Buyer ID:</td>
                  <td class="data">
                    {{ this.record.buyerId}}
                  </td>
                  <td class="first">Buyer Name:</td>
                  <td class="data">
                    <a @click="openUserPage" style="cursor: pointer;">
                      {{ this.record.buyerName}}
                    </a>
                  </td>
                </tr>
                <tr>
                  <td class="first">Payment Time:</td>
                  <td class="data">
                    {{ this.record.payTime}}
                  </td>
                  <td class="first">Payment Method:</td>
                  <td class="data">
                    {{ this.record.payTypeName}}
                  </td>
                  <td class="first">Third-party Order No:</td>
                  <td class="data">
                    {{ this.record.outTradeNo}}
                  </td>
                </tr>
                <tr>
<!--                  <td class="first">Order Amount:</td>
                  <td class="data">
                    {{ this.record.orderAmount}}
                  </td>-->
                  <td class="first">Goods Amount:</td>
                  <td class="data">
                    {{ this.record.goodsAmount}}
                  </td>
                  <td class="first">Goods Quantity:</td>
                  <td class="data">
                    {{ this.record.goodsCount}}
                  </td>
                  <!-- 是否催发货-->
                  <td class="first">Urging Shipment:</td>
                  <td class="data">
                    {{ this.record.isRemind}}
                  </td>
                </tr>
                <tr>
                  <td class="first">Amount Paid:</td>
                  <td class="data">
                    {{ this.record.payAmount}}
                  </td>
                  <td class="first">Shipping Amount:</td>
                  <td class="data">
                    {{ this.record.shippingAmount}}
                  </td>
                  <td class="first">Shipping Paid:</td>
                  <td class="data">
                    {{ this.record.shippingPayAmount}}
                  </td>
                </tr>
                <tr>
                  <td class="first">Discount Amount:</td>
                  <td class="data">{{ formatMoney(totalDiscountAmount) }}</td>
                  <td class="first">Discount Type:</td>
                  <td class="data">{{ discountDescription }}</td>
                  <td class="first">Member Discount Amount:</td>
                  <td class="data">{{ formatMoney(this.record.levelReduceAmount) }}</td>
                </tr>
                <tr>
                  <td class="first">User Remark:</td>
                  <td  colspan="7">
                    {{ this.record.userMessage}}
                  </td>
                </tr>
                <tr>
                  <td class="first">Tag:</td>
                  <td  colspan="7">
                    <editable-cell :value="record.adminRemark" @submit="(submit)=>editRemark(submit,record.id)"/>
                  </td>
                </tr>
<!--                <tr v-if="record.receiveTime">
                  <td class="first">Expected Receipt Time:</td>
                  <td class="data">
                    {{ this.record.receiveTime}}
                  </td>
                  <td class="first"></td>
                  <td class="data">
                    <a-button type="primary" v-if="record.orderStatus===2030"  @click="$refs.receiveTimeForm.handleUpdateReceiveTime(record.id)">
                      Modify Receipt Time
                    </a-button>
                  </td>
                </tr>-->
                <tr v-if="record.isError">
                  <td class="first" style="color: red">Error Info:</td>
                  <td  colspan="5" style="color: red">
                    {{this.record.adminRemark}}
                  </td>
                </tr>
              </table>
            </a-card>
          </td>
        </tr>

        <tr>
          <td style="vertical-align: top;background-color:#fbfbfb;">
            <a-card  :bordered="false" title="Goods Info"
                     :headStyle="{'background-color':'#f3f3f3','height': '29px','border-bottom': '1px solid #DDD','margin-bottom':'0'}"
                     :bodyStyle="{'background-color':'#fbfbfb'}">
              <a slot="extra">
                <a-button type="link" @click="handlePrint" style="margin-right: 8px;">
                  <a-icon type="printer" />
                  Print
                </a-button>
              </a>
              <a-table  :bordered="false" :pagination="false" :columns="goodsColumns" rowKey="skuId" :data-source="record.orderItemList">
                <template slot="goodsName" slot-scope="text, record">
                  <span>{{ record.goodsName }}</span>
                  <a-tag v-if="record.isGift" color="orange" style="margin-left: 8px;">Gift</a-tag>
                </template>
                <template slot="picture" slot-scope="text, record">
                  <div>
                    <img v-if="record.picture" :src="record.picture"  style="width:60px;height:62px;" @click="handleRecordPreview(record.picture)" alt="none"/>
                  </div>
                </template>
              </a-table>
            </a-card>
          </td>
        </tr>

        <tr v-if="record.orderActivityDetail!=null">
          <td style="vertical-align: top;background-color:#fbfbfb;">
            <a-card  :bordered="false" title="Activity Info"
                     :headStyle="{'background-color':'#f3f3f3','height': '29px','border-bottom': '1px solid #DDD','margin-bottom':'0'}"
                     :bodyStyle="{'background-color':'#fbfbfb'}">
              <table class="info-table">
                <tr>
                  <td class="first">Activity No:</td>
                  <td class="data">
                    {{ this.record.orderActivityDetail.id}}
                  </td>
                  <td class="first">Activity Name:</td>
                  <td class="data">
                    {{ this.record.orderActivityDetail.activityName}}
                  </td>
                  <td class="first">Cover Image:</td>
                  <td class="data">
                    <div>
                      <img v-if="record.orderActivityDetail.coverPic" :src="record.orderActivityDetail.coverPic"  style="width:60px;height:62px;" @click="handleRecordPreview(record.orderActivityDetail.coverPic)" alt="none"/>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="first">Start Time:</td>
                  <td class="data">
                    {{ this.record.orderActivityDetail.startTime}}
                  </td>
                  <td class="first">End Time:</td>
                  <td class="data">
                    {{ this.record.orderActivityDetail.endTime}}
                  </td>
                </tr>
              </table>
            </a-card>
          </td>
        </tr>

        <tr>
          <td style="vertical-align: top;background-color:#fbfbfb;">
            <a-card  :bordered="false" title="Shipping Address Info"
                     :headStyle="{'background-color':'#f3f3f3','height': '29px','border-bottom': '1px solid #DDD','margin-bottom':'0'}"
                     :bodyStyle="{'background-color':'#fbfbfb'}">
<!--              <a slot="extra">-->
<!--                <a-button type="link" @click="$refs.changeLogModal.handleDetail(record.id,1);">
                  Change Log
                </a-button>-->
<!--              </a>-->
              <a slot="extra">
                <a-button type="link" @click="copyAddressInfo" style="margin-right: 8px;">
                  <a-icon type="copy" />
                  Copy
                </a-button>
              </a>
              <table class="info-table">
                <tr>
                  <td class="first">Recipient Name:</td>
                  <td class="data">
                    <a @click="openUserPage" style="cursor: pointer;">
                      {{ this.record.orderAddressDetail.realName}}
                    </a>
                  </td>
                  <td class="first">Gender:</td>
                  <td class="data">
                    {{ this.record.orderAddressDetail.sexName}}
                  </td>
                  <td class="first">Phone:</td>
                  <td class="data">
                    {{this.record.orderAddressDetail.mobile}}
                  </td>
                </tr>
                <tr>
                  <td class="first">Country:</td>
                  <td class="data">
                    <custom-dict-tag :options="customDict.UserNationEnum" :value="record.orderAddressDetail.nation"/>
                  </td>
                  <td class="first">Email:</td>
                  <td class="data">
                    {{ this.record.orderAddressDetail.email}}
                  </td>
                </tr>
                <tr>
                  <td class="first">Detailed Address:</td>
                  <td  colspan="5">
                    {{ this.record.orderAddressDetail.areap + this.record.orderAddressDetail.areac + this.record.orderAddressDetail.areax+this.record.orderAddressDetail.detailedAddress}}
                  </td>
                </tr>
              </table>
            </a-card>
          </td>
        </tr>
        <tr v-if="record.deliveryList">
          <td style="vertical-align: top;background-color:#fbfbfb;">
            <a-card  :bordered="false" title="Logistics Information"
                     :headStyle="{'background-color':'#f3f3f3','height': '10px','border-bottom': '1px solid #DDD','margin-bottom':'0'}"
                     :bodyStyle="{'background-color':'#fbfbfb'}">
              <a-table  :bordered="false" :pagination="false" :columns="deliveryColumns" rowKey="skuId" :data-source="record.deliveryList">
                <template slot="logisticDetail" slot-scope="text, deliveryRecord">
                  <div>
                    <a-button type="primary"  @click="$refs.logisticDetail.handleDetail(deliveryRecord.id)">
                      Logistics Details
                    </a-button>
                  </div>
                </template>
                <template slot="logisticDetailDetail" slot-scope="text, deliveryRecord">
                  <div>
                    <a-button type="primary"  @click="openLogistics(deliveryRecord.logisticsName,deliveryRecord.logisticsNo)">
                      Logistics Tracking
                    </a-button>
                  </div>
                </template>
              </a-table>
            </a-card>
          </td>
        </tr>

      </table>
      <logistic-detail ref="logisticDetail"/>
      <receive-time-form ref="receiveTimeForm" @ok="handleDetail(this.record.id)"/>
      <delivery-form ref="deliveryForm" @ok="handleDetail(this.record.id)"/>
      <RefundPartForm ref="refundPartForm" :order="record"  @ok="handleDetail(this.record.id)"/>
      <RefundAmountForm ref="refundAmountForm" :order="record"  @ok="handleDetail(this.record.id)"/>
      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
      <change-log ref="changeLogModal" />
      <!-- 打印用内容，仅打印时显示 -->
      <div id="order-print-area" ref="printArea" class="print-area">
        <div class="print-card">
          <!-- 订单号 -->
          <div class="print-header">
            <img class="print-logo" src="~@/assets/logo.png" alt="logo" />
            <div class="print-badge">
              <span style="font-size: 14px">OrderNo:</span>
              <span class="print-badge-icon">{{ record.id }}</span>
            </div>
          </div>

          <!-- 商品信息（取第一条商品做摘要） -->
          <div class="print-section">
            <div class="print-section-title">Goods Info</div>
            <div class="print-goods-line" v-if="record.orderItemList && record.orderItemList.length">
              <div class="print-goods-name">
                {{ record.orderItemList[0].goodsName }}
              </div>
              <div class="print-goods-sku" v-if="record.orderItemList[0].skuName">
                {{ record.orderItemList[0].skuName }}
              </div>
              <div class="print-goods-qty">
                × {{ record.goodsCount || record.orderItemList[0].goodsCount || 1 }}
              </div>
            </div>
          </div>
          <div style="height: 100px">

          </div>

          <!-- 费用汇总 -->
          <div class="print-section">
            <div class="print-row">
              <span class="print-label">Subtotal</span>
              <span class="print-value">{{ record.goodsCount || 0 }} pcs</span>
              <span class="print-amount">{{ formatMoney(record.goodsAmount) }}</span>
            </div>
            <div class="print-row" v-if="discountAmount && Number(discountAmount) !== 0">
              <span class="print-label">Discount</span>
              <span class="print-value"></span>
              <span class="print-amount discount">$ {{ -formatMoney(discountAmount) }}</span>
            </div>
            <div class="print-row">
              <span class="print-label">Shipping</span>
              <span class="print-amount">$ {{ formatMoney(record.shippingPayAmount || record.shippingAmount) }}</span>
            </div>
            <div class="print-row">
              <span class="print-label">Tax</span>
              <span class="print-value"></span>
              <span class="print-amount">$ {{ formatMoney(printTaxAmount) }}</span>
            </div>
            <div class="print-divider"></div>
            <div class="print-row total-row">
              <span class="print-label">$ Total</span>
              <span class="print-value"></span>
              <span class="print-amount total">$ {{ formatMoney(record.payAmount) }}</span>
            </div>
            <div class="print-row total-row">
              <span class="print-label">$ Amount Paid</span>
              <span class="print-value"></span>
              <span class="print-amount total">$ {{ formatMoney(record.payAmount) }} USD</span>
            </div>
            <div class="print-row total-row">
              <span class="print-label">Store Name</span>
              <span class="print-value"></span>
              <span class="print-amount total">Body Jewelry</span>
            </div>
          </div>

          <!-- 收货地址信息 -->
          <div class="print-section">
            <div class="print-section-title">Shipping Address Info</div>
            <div class="print-address-line">
              <span class="print-address-label"></span>
              <span class="print-address-value">
                {{ record.orderAddressDetail && record.orderAddressDetail.realName }}（{{ record.orderAddressDetail && record.orderAddressDetail.mobile }}）
              </span>
            </div>
            <div class="print-address-line">
              <span class="print-address-label"></span>
              <span class="print-address-value">
                {{ record.orderAddressDetail && (record.orderAddressDetail.areap || '') }}
                {{ record.orderAddressDetail && (record.orderAddressDetail.areac || '') }}
                {{ record.orderAddressDetail && (record.orderAddressDetail.areax || '') }}
                {{ record.orderAddressDetail && (record.orderAddressDetail.detailedAddress || '') }}
              </span>
            </div>
            <div class="print-address-line">
              <span class="print-address-label"></span>
              <span class="print-address-value" style="color: blue;">
                support@ouferbodyjewelry.com 
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-control">
      <a-space>
        <a-button type="primary"  v-hasPermi="['order:sell:delivery']"  v-if="this.record.orderStatus===2020 && this.record.isSplit"  @click="$refs.deliveryForm.handleDelivery(record.id)">
          Ship
        </a-button>
        <a-button type="danger"  v-hasPermi="['order:refund:apply']"  v-if="this.record.orderStatus>2010 && this.record.orderStatus< 2050 && this.record.isSplit"  @click="handleRefund(record.id)">
          Refund
        </a-button>
        <a-button type="danger"  v-hasPermi="['order:refund:apply']"  v-if="this.record.orderStatus>2010 && this.record.orderStatus< 2050 && this.record.isSplit"  @click="$refs.refundAmountForm.handleDetail()">
          Partial Refund
        </a-button>
        <a-button type="dashed" @click="cancel">
          Close
        </a-button>
      </a-space>
    </div>
  </a-drawer>
</template>

<script>
import {getSell,updateRemark} from '@/api/order/sell'
import {mapGetters} from 'vuex'
import LogisticDetail from "./LogisticDetail";
import CustomDictTag from "@/components/DictCustomTag";
import DeliveryForm from "./DeliveryForm";
import ReceiveTimeForm from "./ReceiveTimeForm.vue";
import ChangeLog from "./ChangeLog.vue";
import RefundPartForm from "./RefundPartForm.vue";
import RefundAmountForm from "./RefundAmountForm.vue";
import {refundApply} from "@/api/order/refund";
import EditableCell from "@/components/EditableCell";


export default {
  name: 'detailForm',
  props: {
  },
  components: {
    CustomDictTag,
    EditableCell,
    LogisticDetail,
    ChangeLog,
    DeliveryForm,
    RefundPartForm,
    RefundAmountForm,
    ReceiveTimeForm
  },
  data () {
    return {
      record: {
        id:null,
        orderAddressDetail: {},
        orderRaiseResult: {},
        orderActivityDetail: {},
      } ,
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      // 表单参数
      form: {
        id: null,
        outTradeNo: null,
        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      goodsColumns: [
        {
          title: 'Goods Name',
          dataIndex: 'goodsName',
          scopedSlots: {customRender: 'goodsName'},
          align: 'center',
        },
        {
          title: 'Goods Image',
          dataIndex: 'picture',
          scopedSlots: {customRender: 'picture'},
          align: 'center'
        },
        {
          title: 'Spec Name',
          dataIndex: 'skuName',
          align: 'center'
        },
        {
          title: 'Code',
          dataIndex: 'skuCode',
          align: 'center'
        },
        {
          title: 'Quantity',
          dataIndex: 'goodsCount',
          align: 'center'
        },

        {
          title: 'Price',
          dataIndex: 'price',
          align: 'center'
        },
        {
          title: 'Paid Unit Price',
          dataIndex: 'payPrice',
          align: 'center'
        },
      ],
      deliveryColumns: [
        {
          title: 'Logistics No',
          dataIndex: 'logisticsNo',
          align: 'center',
        },
        {
          title: 'Logistics Company',
          dataIndex: 'logisticsName',
          align: 'center',
        },
        {
          title: 'Shipment Time',
          dataIndex: 'createTime',
          align: 'center'
        },
        {
          title: 'Logistics Details',
          dataIndex: 'logisticDetail',
          scopedSlots: {customRender: 'logisticDetail'},
          align: 'center'
        },
        {
          title: 'Logistics Tracking',
          dataIndex: 'logisticDetailDetail',
          scopedSlots: {customRender: 'logisticDetailDetail'},
          align: 'center'
        },
      ],

      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict']),
    /** 税费：优先用后端字段，否则用 实付 - 商品金额 - 运费 */
    printTaxAmount() {
      const r = this.record
      if (!r) return 0
      if (r.taxPayAmount != null && Number(r.taxPayAmount) >= 0) return r.taxPayAmount
      const pay = Number(r.payAmount) || 0
      const goods = Number(r.goodsAmount) || 0
      const ship = Number(r.shippingPayAmount ?? r.shippingAmount) || 0
      const tax = pay - goods - ship
      return tax >= 0 ? tax : 0
    },
    /** 优惠金额：商品金额+运费+税费 - 实付（若为正） */
    discountAmount() {
      const r = this.record
      if (!r) return 0
      const goods = Number(r.goodsAmount) || 0
      const ship = Number(r.shippingPayAmount ?? r.shippingAmount) || 0
      const pay = Number(r.payAmount) || 0
      const sum = goods + ship + this.printTaxAmount
      const d = sum - pay
      return d > 0 ? d : 0
    },
    totalDiscountAmount() {
      const r = this.record || {}
      return (Number(r.shippingReduceAmount) || 0) +
        (Number(r.platCouponReduceAmount) || 0) +
        (Number(r.levelReduceAmount) || 0)
    },
    discountDescription() {
      const r = this.record || {}
      const types = []
      if (Number(r.shippingReduceAmount) > 0) types.push('Shipping')
      if (Number(r.platCouponReduceAmount) > 0) types.push('Coupon')
      if (Number(r.levelReduceAmount) > 0) types.push('Member')
      return types.join(', ') || '-'
    },
    shippingDesc() {
      const r = this.record
      if (!r || !r.deliveryList || !r.deliveryList.length) return ''
      const first = r.deliveryList[0]
      return (first.logisticsName || '') + (first.logisticsNo ? ' ' + first.logisticsNo : '')
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    copyAddressInfo() {
      const addressInfo = this.record.orderAddressDetail;
      const textToCopy = `Recipient Name: ${addressInfo.realName || ''}\n` +
        `Gender: ${addressInfo.sexName || ''}\n` +
        `Phone: ${addressInfo.mobile || ''}\n` +
        `Email: ${addressInfo.email || ''}\n` +
        `Detailed Address: ${addressInfo.areap || ''}${addressInfo.areac || ''}${addressInfo.areax || ''}${addressInfo.detailedAddress || ''}`;

      this.$copyText(textToCopy).then(() => {
        this.$message.success('Copied successfully');
      }).catch(() => {
        this.$message.error('Copy failed');
      });
    },
    formatMoney(val) {
      if (val == null || val === '') return '0.00'
      const n = Number(val)
      if (isNaN(n)) return '0.00'
      return n.toFixed(2)
    },
    editRemark(remark, id) {
      let data= {"id":id,"adminRemark":remark}
      updateRemark(data).then(response => {
        this.$message.success('Remark saved', 3)
        this.record.adminRemark = remark
      })
    },
    handlePrint() {
      if (!this.record || !this.record.id) {
        this.$message.warning('No order data')
        return
      }
      const printContent = this.$refs.printArea
      if (!printContent) return
      const win = window.open('', '_blank')
      if (!win) {
        this.$message.warning('Please allow pop-ups to print')
        return
      }
      const style = `
        * { margin: 0; padding: 0; box-sizing: border-box; }
        body { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif; padding: 24px; background: #f5f5f5; font-size: 14px; }
        .print-card { background: #fff; border-radius: 12px; padding: 20px 24px; max-width: 480px; margin: 0 auto; box-shadow: 0 1px 3px rgba(0,0,0,0.08); }
        .print-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 16px; }
        .print-logo { width: 40px; height: 40px; object-fit: contain; }
        .print-badge { display: inline-flex; align-items: center; gap: 6px; background: #f0f0f0; color: #333; padding: 0px 0px; border-radius: 6px; font-size: 14px; }
        .print-badge-icon { color: #52c41a; font-weight: bold; }
        .print-row { display: flex; align-items: flex-start; justify-content: space-between; margin-bottom: 12px; line-height: 1.5; }
        .print-label { color: #333; }
        .print-value { flex: 1; text-align: center; color: #666; font-size: 12px; }
        .print-amount { min-width: 80px; text-align: right; color: #333; }
        .print-amount.discount { color: #cf1322; }
        .print-divider { height: 1px; background: #e8e8e8; margin: 16px 0; }
        .total-row .print-amount { font-weight: 600; }
        .total-row .print-amount.total { font-size: 16px; }
      `
      win.document.write(`
        <!DOCTYPE html><html><head><meta charset="utf-8"><title>Order-${this.record.id}</title><style>${style}</style></head><body>${printContent.innerHTML}</body></html>
      `)
      win.document.close()
      win.focus()
      setTimeout(() => {
        win.print()
        win.close()
      }, 300)
    },
        openUserPage () {
          if (!this.record || !this.record.buyerId) {
            return
          }
          const route = this.$router.resolve({
            path: '/user/app/appuser',
            query: {
              userId: this.record.buyerId
            }
          })
          window.open(route.href, '_blank')
        },
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        outTradeNo: null,
        remark: null,
      }
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    openLogistics(com,no) {
      const url = new URL('https://www.kuaidi100.com/chaxun');
      url.searchParams.set('nu', no);
      window.open(url.toString(), "_blank");
    },
    /** 将步骤条中的中文状态翻译为英文显示 */
    translateStatus (text) {
      if (!text) return ''
      const map = {
        // 状态事件 statusEvent
        '创建订单': 'Order Created',
        '接单成功': 'Order Accepted',
        '发货完成': 'Shipped',
        '已完成': 'Completed',
        '取消订单': 'Order Cancelled',
        '交易关闭': 'Trade Closed',
        // 订单状态 orderStatusName
        '待付款': 'Pending Payment',
        '待发货': 'Pending Shipment',
        '待收货': 'Pending Receipt',
        '已取消': 'Cancelled',
        '已发货': 'Shipped'
      }
      return map[text] || text
    },
    /** 修改按钮操作 */
    handleDetail(id) {
      this.reset()
      this.formType = 2
      getSell({"id":id}).then(response => {
        this.record = response.data
        this.open = true
      })
    },
    handleRefund(id) {
      let that = this
      let form = {"orderId":id ,"remark":"Manual backend refund"}
      this.$confirm({
        title: 'Confirm Refund',
        content: 'This operation will create a refund order and process the refund',
        onOk () {
          that.record.orderStatus =2070
          refundApply(form).then(resp => {
            if (resp.code==="20001") {
              this.$message.success(
                'Refund successful',
                3
              );
              this.handleDetail(id)
              this.record.orderStatus =2070
              this.open = false
              this.$emit('ok')
            }
          });
        },
        onCancel () {}
      })
    },

    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            payAdvert(this.form).then(response => {
              this.$message.success(
                'Payment successful',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.title {
  color: rgba(0, 0, 0, .85);
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 16px;
}

/* 步骤条样式优化 */
.step-event {
  font-size: 16px;
  font-weight: 600;
  color: #1890ff;
  margin-bottom: 2px;
}
.step-status {
  font-size: 13px;
  color: #666;
  margin-bottom: 2px;
}
.step-remark {
  font-size: 12px;
  color: #fa8c16;
  margin-bottom: 2px;
}
.step-time {
  font-size: 12px;
  color: #999;
}

.message-text {
  font-family: MicrosoftYaHei;
  font-size: 1rem;
  font-weight: normal;
  font-stretch: normal;
  line-height: 3rem;
  letter-spacing: 0rem;
  color: #333333;
  width: 50%;
}

.fontblack {
  color: #999999
}

.img2 {
  width: .81rem;
  height: .8rem;
  float: right;
}


.orderTitle {
  font-size: 1rem;
  color: #333333;
  height: auto;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
  word-wrap: break-word;
  word-break: break-all;
  height: 2.5rem;
}

.orderDetail {
  font-size: 0.8rem;
  color: #666666;
  text-align: left;
}

.border-ceter {
  width: 92%;
  padding-left: 15px;
  padding-right: 15px;
}

.pay-button {
  width: 88%;
  height: 2.6rem;
  position: relative;
  background-color: red;
  color: white;

  margin-left: 6%;
}

ul li {
  list-style: none;
  font-size: 1rem;
}

ul {
  padding-left: 1.5rem
}

.track-rcol {
}

.track-list {
  position: relative;
}

.track-list li {
  position: relative;
  padding: 0px 0 1.5rem 25px;
  line-height: 1rem;
  border-left: 1px solid #d9d9d9;
  color: #999;
}

.track-list li.first {
  color: red;
  padding-top: 0;
  width: 100%;
  text-align: left;
  border-left: 1px solid #d9d9d9;
}

.track-list li .node-icon {
  position: absolute;
  left: -5.5px;
  border-radius: 0.25rem;
  width: 0.5rem;
  height: 0.5rem;
  top: 4px;
  background-color: #999999;
}

.track-list li.first .node-icon {
  background-position: 0-72px;
  background-color: red;
  width: 1rem;
  z-index: 2;
  height: 1rem;
  position: absolute;
  left: -9px;
  top: 0;
  border-radius: 0.5rem;
}

.track-list li .time {
  margin-right: 20px;
  position: relative;
  top: 4px;
  display: inline-block;
  vertical-align: middle;
  background-color: white;
  color: #999;
  width: 100%;
  text-align: left;
}

.track-list li .txt {
  position: relative;
  display: inline-block;
  vertical-align: top;
  color: #999;
}

.track-list li.first .time {
  text-align: left;
  width: 94%;
  color: red;
}

.track-list li.first .txt {
  color: red;
  text-align: left;
  width: 94%;
}

.track-list li.finall {
  position: relative;
  padding: 0px 0 1.5rem 25px;
  line-height: 18px;
  border-color: white;
  border-left: 1px solid #ffffff;
  color: #999;
}

.track-list li.finall .div-spilander {
  width: 1px;
  position: absolute;
  position: absolute;
  left: -1.5px;
  height: 0.5rem;
  background-color: #d9d9d9;
}

.order-info {
  border: 1px solid #e8e8e8;
  margin-top: 40px;

  .info-table {
    tr {
      height: 50px;
    }
    td {
      display: table-cell;
      vertical-align: top;
      font-size: 16px;
    }

    .first {
      width: 100px;
    }

    .data {
      width: 300px;
    }
  }
}

.detailPanel {
  dd, dt {
    display: inline-block;
    vertical-align: center;
  }

  dt img {
    margin: 0 20px 5px 0px;
  }

  dd {
    h3 {
      font-weight: bold;
    }
  }

  .trade-detail-prompt {
    margin-left: 35px;

    li {
      font-size: 13px !important;

      .dotted-node {
        padding: 0 5px;
      }
    }
  }
}

/* 打印区域在页面中隐藏，仅用于生成打印内容 */
.print-area {
  position: absolute;
  left: -9999px;
  top: 0;
  width: 1px;
  height: 1px;
  overflow: hidden;
  pointer-events: none;
}

.print-section {
  margin-bottom: 12px;
}

.print-section-title {
  font-weight: 600;
  margin-bottom: 6px;
  font-size: 14px;
}

.print-goods-line {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  font-size: 13px;
  color: #333;
}

.print-goods-name {
  margin-right: 8px;
}

.print-goods-sku {
  margin-right: 8px;
  color: #666;
}

.print-goods-qty {
  margin-left: auto;
}

.print-address-line {
  font-size: 13px;
  margin-bottom: 4px;
}

.print-address-label {
  color: #666;
  margin-right: 4px;
}

.print-address-value {
  color: #333;
}

.order-money {
  .om-c1 {
    font-size: 14px;
    color: #666
  }

  .om-c2 {
    font-size: 16px;
    color: #333;
    font-weight: bold;
  }

  .om-c3 {
    font-size: 16px;
    color: #DE3636;
    font-weight: bold;
  }

  td {
    text-align: right;
  }

  float: right;
  margin: 20px 40px 20px 0;
}
</style>
